fragment ContractListFields on Contract {
  id
  title
  contractType
  purpose
  status
  legalEntity {
    id
    name
  }
  counterpartyLegalName
  counterpartyWorkingName
  owner {
    id
    name
  }
  ownerLeft
  team {
    id
    name
  }
  expiresOn
  autoRenews
  noticeByOn
  deadlineOn
  renewalDecision
  value {
    minorUnit
    currency
  }
  valuePeriod
}
